import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'General',
      type: 'details',
      content: {
        '{}': {
          fields: {
            if: [
              [
                {
                  '!=': [
                    {
                      '@': 'fieldsForCurrentRecord',
                    },
                    null,
                  ],
                },
                {
                  '@': 'fieldsForCurrentRecord',
                },
              ],
              {
                '[]': [
                  {
                    '{}': {
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Mission',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value:
                        'Give leaders the confidence to pursue their boldest visions and the clarity to pursue them wisely.',
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Product Vision',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value:
                        "The leader's go-to source of business intelligence, delivering not just data, but the understanding that drives confident decision-making.",
                      readonly: true,
                    },
                  },
                ],
              },
            ],
          },
          columnCount: 2,
        },
      },
    },
  },
  variables: {
    currentEntityId: 'ent:!outcomes:!goal',
    currentRecordId: '?pro',
  },
  subqueries: {
    fieldsForCurrentRecord: {
      filter: {
        and: [
          {
            '=': [
              {
                '@_': 'id',
              },
              {
                '@$': 'currentEntityId',
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!id',
              },
              {
                '@$': 'currentRecordId',
              },
            ],
          },
        ],
      },
      target: 'dim::!outcomes',
      quantity: 1,
      selection: {
        '[]': [
          {
            '{}': {
              meta: {
                '{}': {
                  direct: {
                    '{}': {
                      name: 'Outcome Type',
                      type: 'TEXT',
                    },
                  },
                },
              },
              value: {
                '@_': 'name',
              },
              readonly: true,
            },
          },
          {
            '{}': {
              meta: {
                '{}': {
                  direct: {
                    '{}': {
                      name: 'Description',
                      type: 'TEXT',
                    },
                  },
                },
              },
              value: {
                '@.': '!descr',
              },
              readonly: true,
            },
          },
          {
            '{}': {
              meta: {
                '{}': {
                  direct: {
                    '{}': {
                      name: 'Suboutcomes',
                      type: 'LIST',
                    },
                  },
                },
              },
              value: {
                '@': 'suboutcomes',
              },
              readonly: true,
            },
          },
        ],
      },
      subqueries: {
        suboutcomes: {
          target: 'child',
          selection: {
            '@.': '!name',
          },
        },
      },
    },
  },
}
